var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3106 9.65631C14.3106 9.79349 14.2561 9.92506 14.1591 10.0221C14.0621 10.1191 13.9305 10.1736 13.7933 10.1736H7.4571L9.67779 12.3938C9.77496 12.491 9.82955 12.6228 9.82955 12.7602C9.82955 12.8976 9.77496 13.0294 9.67779 13.1266C9.58062 13.2237 9.44883 13.2783 9.31141 13.2783C9.17399 13.2783 9.0422 13.2237 8.94503 13.1266L5.84159 10.0231C5.79336 9.97507 5.7551 9.91797 5.729 9.8551C5.70289 9.79223 5.68945 9.72482 5.68945 9.65674C5.68945 9.58867 5.70289 9.52126 5.729 9.45839C5.7551 9.39552 5.79336 9.33842 5.84159 9.29036L8.94503 6.18692C8.99315 6.1388 9.05027 6.10064 9.11313 6.0746C9.17599 6.04856 9.24337 6.03516 9.31141 6.03516C9.37946 6.03516 9.44683 6.04856 9.5097 6.0746C9.57256 6.10064 9.62968 6.1388 9.67779 6.18692C9.72591 6.23503 9.76407 6.29215 9.79011 6.35501C9.81615 6.41788 9.82955 6.48525 9.82955 6.55329C9.82955 6.62134 9.81615 6.68871 9.79011 6.75158C9.76407 6.81444 9.72591 6.87156 9.67779 6.91967L7.4571 9.13907H13.7933C13.9305 9.13907 14.0621 9.19357 14.1591 9.29057C14.2561 9.38757 14.3106 9.51913 14.3106 9.65631Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.3e0ae8264a3aa65e3e2f7dfc5718bf97.svg";
export { ForwardRef as ReactComponent };